<template>
  <div>
    <v-col cols="12">
      <v-row>
        <v-col cols="12" v-if="informText != ''">
          <v-alert type="error" v-if="informText != ''">{{
            informText
          }}</v-alert>
        </v-col>
        <v-col cols="12">
          <v-row>
            <v-spacer></v-spacer>
            <span style="padding-top: 10px; padding-right: 3px">
              <b>Idea ID: </b> {{ ideaData._id }} - <b>Created Date: </b>
              {{ ideaData.created_date }} - <b>Status :</b></span
            >
            <span style="width: 350px">
              <v-select
                :items="listStatus"
                dense
                outlined
                hide-details
                v-model="ideaData.status"
              ></v-select>
            </span>
            <v-spacer></v-spacer>
            <v-btn
              style="float: right"
              small
              color="orange"
              @click="cancelData"
              dark
              >Cancel</v-btn
            >
          </v-row>
          <!-- <v-btn style="float: right" small color="orange" @click="check" dark
            >Check</v-btn
          > -->
        </v-col>
        <v-col cols="6" class="pa-1 ma-0">
          <v-select
            :items="listIdea"
            label="Idea"
            v-model="ideaData.idea"
            dense
            outlined
            hide-details
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            @change="validation"
            disabled
          ></v-select>
        </v-col>
        <v-col cols="6" class="pa-1 ma-0" v-if="roles.approve_idea">
          <v-row class="pa-0 ma-0">
            <v-col cols="8" class="pa-0 ma-0">
              <span style="float: left; margin-right: 10px">Approval: </span>
              <v-radio-group
                v-model="ideaData.approval"
                row
                class="pa-0 ma-0"
                hide-details
              >
                <v-radio label="Go Ahead" value="Go ahead"></v-radio>
                <v-radio
                  label="Reject"
                  value="Reject"
                ></v-radio> </v-radio-group
            ></v-col>
            <v-col cols="4" class="pa-0 ma-0">
              <v-select
                :items="listPriority"
                dense
                hide-details
                outlined
                label="Priority"
                v-model="ideaData.priority"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6" class="pa-1 ma-0" v-else>
          <v-row class="pa-0 ma-0">
            <v-col cols="8" class="pa-0 ma-0">
              <span style="float: left; margin-right: 10px">Approval: </span>
              <v-radio-group
                v-model="ideaData.approval"
                row
                class="pa-0 ma-0"
                hide-details
                disabled
              >
                <v-radio label="Go Ahead" value="Go ahead"></v-radio>
                <v-radio
                  label="Reject"
                  value="Reject"
                ></v-radio> </v-radio-group
            ></v-col>
            <v-col cols="4" class="pa-0 ma-0">
              <v-select
                :items="listPriority"
                dense
                hide-details
                outlined
                label="Priority"
                disabled
                v-model="ideaData.priority"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6" class="pa-1 ma-0"
          ><v-select
            :items="listDesigner"
            label="Artist"
            v-model="ideaData.artist"
            dense
            outlined
            hide-details
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            v-if="roles.update_idea"
          ></v-select>
          <v-select
            :items="listDesigner"
            label="Artist"
            v-model="ideaData.artist"
            dense
            outlined
            hide-details
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            v-else
            disabled
          ></v-select>
        </v-col>
        <v-col cols="6" class="pa-1 ma-0">
          <v-text-field
            dense
            outlined
            hide-details
            v-model="ideaData.product_code"
            label="Product Code"
            @keyup="validation"
            v-if="roles.update_idea"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            hide-details
            v-model="ideaData.product_code"
            label="Product Code"
            @keyup="validation"
            v-else
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="6" class="pa-1 ma-0">
          <v-select
            :items="listDesigner"
            label="Scaler"
            v-model="ideaData.scaler"
            dense
            hide-details
            outlined
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            v-if="roles.update_idea"
          ></v-select>
          <v-select
            :items="listDesigner"
            label="Scaler"
            v-model="ideaData.scaler"
            dense
            hide-details
            outlined
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            v-else
            disabled
          ></v-select>
        </v-col>
        <v-col cols="6" class="pa-1 ma-0">
          <v-text-field
            dense
            outlined
            hide-details
            v-model="ideaData.product_title"
            label="Product Title"
            @keyup="validation"
            v-if="roles.update_idea"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            hide-details
            v-model="ideaData.product_title"
            label="Product Title"
            @keyup="validation"
            v-else
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="6" class="pa-1 ma-0">
          <v-select
            :items="listUploader"
            label="Uploader"
            v-model="ideaData.uploader"
            dense
            outlined
            hide-details
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            v-if="roles.update_idea"
          ></v-select>
          <v-select
            :items="listUploader"
            label="Uploader"
            v-model="ideaData.uploader"
            dense
            outlined
            hide-details
            :item-text="(obj) => obj.name"
            :item-value="(obj) => obj.username"
            v-else
            disabled
          ></v-select>
        </v-col>
        <v-col cols="6" class="pa-1 ma-0">
          <v-select
            :items="listProductType"
            label="Product Type"
            v-model="ideaData.product_type_id"
            dense
            outlined
            hide-details
            :item-text="(obj) => obj.product_type"
            :item-value="(obj) => obj._id"
            v-if="roles.update_idea"
          ></v-select>
          <v-select
            :items="listProductType"
            label="Product Type"
            v-model="ideaData.product_type_id"
            dense
            outlined
            hide-details
            :item-text="(obj) => obj.product_type"
            :item-value="(obj) => obj._id"
            v-else
            disabled
          ></v-select>
        </v-col>

        <v-row class="pa-0 ma-0" style="text-align: left">
          <v-col cols="1">
            <input
              type="file"
              @change="onFileChange"
              multiple
              ref="inputPreview"
              style="display: none"
            />
            <v-btn
              small
              color="info"
              @click="$refs.inputPreview.click()"
              class="btn btn-sm btn-secondary"
              v-if="showBtnImg"
            >
              Select Image
            </v-btn>
            <v-btn
              small
              color="info"
              class="btn btn-sm btn-secondary"
              v-else
              disabled
            >
              Select Image
            </v-btn>
            <v-btn
              small
              @click="uploadImage"
              style="float:left,margin-bottom:5px;margin-top:5px"
              color="success"
              v-if="imageUpload.length > 0 && showBtnImg"
              >Add Image</v-btn
            >
            <v-btn
              small
              style="float:left,margin-bottom:5px;margin-top:5px"
              color="success"
              v-else
              disabled
              >Add Image</v-btn
            >
            <v-btn
              small
              @click="cancelImageUpload"
              color="orange"
              dark
              style="float:left,margin-bottom:5px;margin-top:5px"
              v-if="imageUpload.length > 0 && showBtnImg"
              >Cancel Image</v-btn
            >
            <v-btn
              small
              color="orange"
              style="float:left,margin-bottom:5px;margin-top:5px"
              v-else
              disabled
              >Cancel Image</v-btn
            >
          </v-col>
          <v-col cols="11">
            <span v-for="(i, index) of imageUpload" :key="index">
              <img :src="i.image" style="width: 150px; margin-left: 5px" />
            </span>
          </v-col>
          <v-col cols="11" v-if="ideaData.idea_images">
            <template v-if="ideaData.idea_images.length > 0">
              Preview Idea:
              <template v-for="(i, index) of ideaData.idea_images">
                <img :key="i" :src="i" style="width: 150px; margin-left: 5px" />
                <v-btn
                  :key="index"
                  color="orange"
                  dark
                  small
                  @click="removeImage(index)"
                  style="position: absolute; transform: translate(-115%, 100%)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </template>
          </v-col>
        </v-row>
        <v-col cols="12" class="pa-1 ma-0">
          <!-- <ckeditor
            :editor="editor"
            v-model="ideaData.idea_description"
          ></ckeditor> -->

          <!-- <v-btn @click="addIMG" style="float:left,margin-bottom:5px"
            >Add Image</v-btn
          > -->
          <ckeditor
            v-model="ideaData.idea_description"
            style="height: 350px"
          ></ckeditor>
        </v-col>
        <v-col cols="6" class="pa-1 ma-0">
          <v-text-field
            dense
            outlined
            v-model="ideaData.banner_link"
            label="Banner Link"
            v-if="roles.upload_resource"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            v-model="ideaData.banner_link"
            label="Banner Link"
            v-else
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="6" class="pa-1 ma-0">
          <v-text-field
            dense
            outlined
            v-model="ideaData.resource_link"
            label="Resource Link"
            v-if="roles.upload_resource"
          ></v-text-field>
          <v-text-field
            dense
            outlined
            hide-details
            v-model="ideaData.resource_link"
            label="Resource Link"
            v-else
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-btn
            small
            color="success"
            @click="saveData"
            v-if="
              showBtn == true &&
              (roles.upload_resource || roles.approve_idea || roles.update_idea)
            "
            >Save</v-btn
          >
          <v-btn small disabled v-else>Save</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import axios from "axios";
import Amplify, { Auth } from "aws-amplify";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

const MAX_IMAGE_SIZE = 6300000;

export default {
  name: "IdeaEdit",

  props: {
    userId: String,
    listIdea: Array,
    listDesigner: Array,
    listUploader: Array,
    listProductType: Array,
    ideaData: Object,
  },

  data: () => ({
    item: {
      idea: "",
      artist: "",
      scaler: "",
      uploader: "",
      product_title: "",
      product_type_id: "",
      idea_description: "",
      priority: "",
    },
    showBtn: false,
    informText: "",
    roles: [],
    editor: ClassicEditor,
    listPriority: ["Normal", "High", "Urgent"],
    listStatus: [
      "Need Approval",
      "Making Art",
      "Uploading",
      "Completed",
      "Canceled",
    ],
    imageUpload: [],
    imageFormat: "",
    preview_imgs: [],
    showBtnImg: true,
    timeStamp: "",
  }),

  methods: {
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      
      for(let i of files){
        this.createImage(i);
      }
      
      // files.forEach((element) => {
      //   this.createImage(element);
      // });
    },

    cancelImageUpload() {
      this.imageUpload = [];
    },

    createImage(file) {
      this.informText = "";
      let reader = new FileReader();
      reader.onload = (e) => {
        if (e.target.result.includes("data:image/jpeg")) {
          this.imageFormat = "image/jpeg";
        } else if (e.target.result.includes("data:image/png")) {
          this.imageFormat = "image/png";
        } else if (e.target.result.includes("data:image/bmp")) {
          this.imageFormat = "image/bmp";
        } else {
          return (this.informText = "Wrong file type - JPG/PNG/BMP only.");
        }

        console.log("e.target.result.length: ", e.target.result.length);
        if (e.target.result.length > MAX_IMAGE_SIZE) {
          return (this.informText = "Image is loo large - 4.7MB maximum");
        }

        var image = {
          image: e.target.result,
          format: this.imageFormat,
        };

        this.imageUpload.push(image);
      };
      reader.readAsDataURL(file);
      //this.uploadImage()
    },

    async uploadImage() {
      this.showBtnImg = false;
      let axiosArray = [];
      var currentSession = await this.$root.$refs.App.currentSession(
        "idea-preview-uploadimageUpload"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        for (let x = 0; x < this.imageUpload.length; x++) {
          let postData = {};
          var base64EncodedStr = this.imageUpload[x].image.split(",")[1];

          postData["image_base64"] = base64EncodedStr;
          postData["image_folder"] = "idea-image";
          postData["image_format"] = this.imageUpload[x].format;
          postData["product_id"] = this.timeStamp;
          let newPromise = axios({
            method: "post",
            url: window.domain + "products/upload-image",
            headers: { Authorization: currentSession.accessToken },
            data: postData,
          });
          axiosArray.push(newPromise);
        }
      } else {
        console.log(
          "currentSession image-preview-uploadimageUpload: ",
          currentSession
        );
      }

      let all = await axios.all(axiosArray).catch((error) => {
        console.log(error);
      });

      console.log(all);
      if (this.ideaData.idea_images) {
        for (const i of all) {
          this.ideaData.idea_images.push(i.data.data.image_url);
        }
      } else {
        this.ideaData["idea_images"] = [];
        for (const i of all) {
          this.ideaData.idea_images.push(i.data.data.image_url);
        }
      }

      this.imageUpload = [];

      this.showBtnImg = true;
    },

    async saveData() {
      this.showBtn = false;
      var currentSession = await this.$root.$refs.App.currentSession(
        "dialog-idea-create-sendAPI"
      );

      this.ideaData["new_status"] = this.ideaData.status;

      console.log(this.ideaData);

      if (currentSession.accessToken) {
        await fetch(window.domain + "ideas/" + this.ideaData._id, {
          method: "PUT",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(this.ideaData),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Create Idea response: ", data);
            if (data.error_message == "") {
              this.cancelData();
            } else {
              this.informText = data.error_message;
            }
          })
          .catch((error) => console.log("Err: ", error));
      } else {
        console.log(
          "currentSession dialog-idea-create-sendAPI-undefined: ",
          currentSession
        );
      }
      this.showBtn = true;
    },
    validation() {
      if (this.ideaData.idea != "" && this.ideaData.product_title != "") {
        this.showBtn = true;
        //this.informText = "";
      } else {
        this.showBtn = false;
        // this.informText =
        //   "Please upload banner image to gba-public/personalized_resources folder on Amazon S3.\nThe maximum size of the resource is 5GB, please ZIP before uploading.";
      }
    },

    cancelData() {
      this.$root.$refs.idea.turnOffDialog();
    },

    removeImage(index) {
      console.log(index);
      this.ideaData.idea_images.splice(index, 1);
      console.log(this.ideaData.idea_images);
    },

    check() {
      console.log("preview_imgs: ", this.preview_imgs);
    },
  },

  async mounted() {
    console.log("idea: ", this.ideaData);
    this.roles = await this.$cookies.get("idea");
    if (this.roles.read_idea) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }

    var tempCheck = false;
    for (const i of this.listIdea) {
      if (i.username == this.userId) {
        tempCheck = true;
        break;
      } else {
        tempCheck = false;
      }
    }
    if (!tempCheck) {
      this.listIdea.push({ name: this.userId, username: this.userId });
    }
    this.validation();
    this.timeStamp =
      Date.now().toString() + Math.floor(Math.random() * 10).toString();
  },
};
</script>

<style lang="scss">
.ck-editor__editable {
  min-height: 250px;
}
</style>